module.exports = __webpack_public_path__ + "privatesAsset.9cd7dca9da5aaeaf0f16818871d3da82.png";